import axios from "axios";

function them(donVi){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/donvi/them",donVi);
};
function getAll(){
  return axios.get(process.env.REACT_APP_URL_SERVER+"/cus/donvi/getall");
};
function capNhat(donVi){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/donvi/capnhat",donVi);
};
function xoa(ids){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/donvi/xoa",ids);
};

const DonViService={
  them,
  getAll,
  capNhat,
  xoa

};
export default DonViService;
